<div class="nav-menu">
  @for (navItem of navMenuItems(); track navItem) {
  <button mat-icon-button (click)="onClick(navItem)">
    <mat-icon class="material-icons-outlined">{{ navItem.icon }}</mat-icon>
  </button>
  } @if (navMenuItems().length > 0) {
  <div class="vertical-divider"></div>
  }
  <button
    mat-icon-button
    class="menu-button avatar"
    [matMenuTriggerFor]="headerMenu"
    (click)="onMenuOpen()"
  ></button>
</div>

<mat-menu #headerMenu="matMenu" class="header-menu">
  <div class="user-section">
    <img
      class="avatar"
      src="./assets/images/avatar.png"
      alt="User"
      height="250"
      width="250"
    />
    <div class="user-info">
      <p class="bold">{{ name() }}</p>
      @if (email(); as email) {
      <div>
        <p>{{ email }}</p>
      </div>
      }
    </div>
  </div>
  @for (dropdownItem of dropdownItems(); track dropdownItem; let i = $index; let
  last = $last) { @if (last) {
  <hr />
  }
  <div
    mat-menu-item
    class="item"
    (click)="onClick(dropdownItem)"
    [id]="dropdownItem.id || 'dropdown-' + i"
  >
    @if (!last) {
    <mat-icon class="material-icons-outlined gray">{{
      dropdownItem.icon
    }}</mat-icon>
    }
    {{ dropdownItem.labelKey | translate }}
  </div>
  }
</mat-menu>
